export default {"src":"/_next/static/media/facebook.1bfac4dc.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};